package ru.villawonka.app.presentation.screens.setup.viewmodel

import ru.villawonka.app.common.mvvm.BaseViewModel
import ru.villawonka.app.common.utils.fold
import ru.villawonka.app.domain.model.NetworkFailure
import ru.villawonka.app.domain.model.UserSettingsDomain
import ru.villawonka.app.domain.usecase.GetAvailableCountriesUseCase
import ru.villawonka.app.domain.usecase.GetAvailableCurrenciesUseCase
import ru.villawonka.app.domain.usecase.GetAvailableLanguagesUseCase
import ru.villawonka.app.domain.usecase.GetUserSettingsUseCase
import ru.villawonka.app.domain.usecase.UpdateUserSettingsUseCase
import ru.villawonka.app.getLogger
import ru.villawonka.app.presentation.model.CountryUIModel
import ru.villawonka.app.presentation.model.CurrencyUIModel
import ru.villawonka.app.presentation.model.LanguageUIModel
import ru.villawonka.app.presentation.model.toDomainModel
import ru.villawonka.app.presentation.model.toUIModel
import ru.villawonka.app.presentation.screens.searchFilter.viewmodel.SearchFilterUIState
import ru.villawonka.app.presentation.screens.setup.model.toCountryButtonUiModel

class SetupViewModel(
    private val getAvailableCountriesUseCase: GetAvailableCountriesUseCase,
    private val getAvailableCurrenciesUseCase: GetAvailableCurrenciesUseCase,
    private val getAvailableLanguagesUseCase: GetAvailableLanguagesUseCase,
    private val updateUserSettingsUseCase: UpdateUserSettingsUseCase,
    private val getUserSettingsUseCase: GetUserSettingsUseCase,
) : BaseViewModel<SetupUIState>() {

    private var currentUserSettings: UserSettingsDomain? = null

    init {
        loadScreen()
    }

    override fun createInitialState() = SetupUIState.Loading


    fun onLanguageSelected(language: LanguageUIModel) = updateSettings(
        update = { it.copy(language = language.toDomainModel()) },
        onSuccess = {
            setState(SetupUIState.Step.Country(
                options = getAvailableCountriesUseCase()
                    .map { it.toUIModel() }
                    .map { it.toCountryButtonUiModel() }
            ))
        }
    )

    fun onCountrySelected(country: CountryUIModel) = updateSettings(
        update = { it.copy(country = country.toDomainModel()) },
        onSuccess = {
            setState(SetupUIState.Step.Currency(
                options = getAvailableCurrenciesUseCase()
                    .map { it.toUIModel() }
            ))
        }
    )

    fun onCurrencySelected(currency: CurrencyUIModel) = updateSettings(
        update = { it.copy(currency = currency.toDomainModel()) },
        onSuccess = {
            setState(SetupUIState.Step.Congrats)
        }
    )

    fun onContinueButtonClick() = launch { shootEvent(SetupUIEvent.Close) }

    fun onRetryButtonClick() = launch { loadScreen() }

    private fun loadScreen() = launch {
        getUserSettingsUseCase().fold(
            ifLeft = { setState(SetupUIState.Error(it)) },
            ifRight = { currentUserSettings = it }
        )

        setState(SetupUIState.Step.Language(
            options = getAvailableLanguagesUseCase()
                .map { it.toUIModel() }
        ))
    }

    private fun updateSettings(
        update: (UserSettingsDomain) -> UserSettingsDomain,
        onSuccess: suspend () -> Unit
    ) = launch {
        val settings = currentUserSettings ?: return@launch
        currentUserSettings = update(settings).also { newSettings ->
            updateUserSettingsUseCase(newSettings).fold(
                ifLeft = { setState(SetupUIState.Error(it)) },
                ifRight = { onSuccess() }
            )
        }
    }
}